var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	6078: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	93649: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	50064: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	67629: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	24951: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	82512: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	69930: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	48394: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	65428: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	69347: {
		fallback: () => (__webpack_require__.e("node_modules_auth0_auth0-spa-js_dist_auth0-spa-js_production_esm_js").then(() => (() => (__webpack_require__(/*! @auth0/auth0-spa-js */ 86377))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.21.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/auth0-spa-js",

	},
	29941: {
		fallback: () => (__webpack_require__.e("node_modules_azure_msal-browser_dist_index_mjs").then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 74102))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5.14.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-browser",

	},
	44525: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_ngrx_store_fesm2022_ngrx-store_mjs")]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	69066: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	68983: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @snelstart/util-state-store */ 27964))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-state-store",

	},
	65041: {
		fallback: () => (__webpack_require__.e("default-libs_shared_util-events_src_index_ts").then(() => (() => (__webpack_require__(/*! @snelstart/util-events */ 43532))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-events",

	},
	47051: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ngrx_store_ngrx_store"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-state-store_snelstart_util-state-store"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-events_snelstart_util-events"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_models-environment_snelstart_models-environment"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-feature-flag_snelstart_util-feature-flag"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular"), __webpack_require__.e("default-libs_shared_util_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/util */ 13728))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util",

	},
	4763: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @snelstart/models-environment */ 41078))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/models-environment",

	},
	48373: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @snelstart/util-address */ 70581))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-address",

	},
	7853: {
		fallback: () => (__webpack_require__.e("default-libs_shared_util-company-info_src_index_ts").then(() => (() => (__webpack_require__(/*! @snelstart/util-company-info */ 86147))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-company-info",

	},
	81545: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-icon */ 56670))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-icon",

	},
	91767: {
		fallback: () => (__webpack_require__.e("default-libs_shared_ui-badge_src_index_ts").then(() => (() => (__webpack_require__(/*! @snelstart/ui-badge */ 99704))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-badge",

	},
	81881: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-tooltip_snelstart_ui-tooltip"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-action-sheet_snelstart_ui-action-sheet"), __webpack_require__.e("default-libs_shared_ui-side-navigation_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-side-navigation */ 89480))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-side-navigation",

	},
	51596: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__array-chunk_mjs-node_modules_angular_cdk_fesm2022_-8f4cb4"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_a11y_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	11240: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022__array-chunk_mjs-node_modules_angular_cdk_fesm2022_-8f4cb4"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_overlay_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	44272: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	98969: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-tooltip_snelstart_ui-tooltip"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-route-state_snelstart_util-route-state"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-loading_snelstart_ui-loading-webpack_sha-d03ddc"), __webpack_require__.e("default-libs_shared_ui-button_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-button */ 36071))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-button",

	},
	80271: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_bootstrap_bootstrap"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-tooltip */ 6408))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-tooltip",

	},
	2983: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/util-route-state */ 23140))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-route-state",

	},
	45497: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @snelstart/ui-loading */ 8391))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-loading",

	},
	52191: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util_snelstart_util"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-route-state_snelstart_util-route-state"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-feature-flag_snelstart_util-feature-flag"), __webpack_require__.e("default-libs_shared_ui_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui */ 51874))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui",

	},
	95807: {
		fallback: () => (__webpack_require__.e("node_modules_bootstrap_dist_js_bootstrap_esm_js").then(() => (() => (__webpack_require__(/*! bootstrap */ 83527))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5.3.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "bootstrap",

	},
	78807: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @snelstart/util-logging */ 68208))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-logging",

	},
	65541: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon"), __webpack_require__.e("default-libs_shared_ui-alert_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-alert */ 33433))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-alert",

	},
	1086: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	3853: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_bootstrap_bootstrap"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-button_snelstart_ui-button"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-logging_snelstart_util-logging"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-alert_snelstart_ui-alert"), __webpack_require__.e("default-libs_shared_ui-dialog_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-dialog */ 8163))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-dialog",

	},
	44371: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_bootstrap_bootstrap"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-logging_snelstart_util-logging"), __webpack_require__.e("default-libs_shared_ui-toast_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-toast */ 9332))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-toast",

	},
	76909: {
		fallback: () => (__webpack_require__.e("default-libs_shared_ui-action-sheet_src_index_ts").then(() => (() => (__webpack_require__(/*! @snelstart/ui-action-sheet */ 20643))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-action-sheet",

	},
	64929: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_snelstart_ui-tooltip_snelstart_ui-tooltip"), __webpack_require__.e("default-libs_shared_ui-tooltip-trigger_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/ui-tooltip-trigger */ 90125))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/ui-tooltip-trigger",

	},
	21681: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_util-events_snelstart_util-events"), __webpack_require__.e("default-webpack_sharing_consume_default_snelstart_models-environment_snelstart_models-environment"), __webpack_require__.e("default-libs_shared_domain-logic_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @snelstart/domain-logic */ 71899))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/domain-logic",

	},
	45850: {
		fallback: () => (__webpack_require__.e("node_modules_mathjs_lib_esm_index_js").then(() => (() => (__webpack_require__(/*! mathjs */ 9359))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "mathjs",

	},
	78001: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/util-feature-flag */ 86266))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-feature-flag",

	},
	40107: {
		fallback: () => (__webpack_require__.e("node_modules_bufbuild_protobuf_dist_esm_wire_index_js").then(() => (() => (__webpack_require__(/*! @bufbuild/protobuf/wire */ 6174))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.12.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bufbuild/protobuf/wire",

	},
	95341: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-node_modules_auth0_auth0-angular_fesm2022_auth0-auth0-angular_mjs")]).then(() => (() => (__webpack_require__(/*! @auth0/auth0-angular */ 37989))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.9.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/auth0-angular",

	},
	66832: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @auth0/angular-jwt */ 92389))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/angular-jwt",

	},
	20188: {
		fallback: () => (Promise.all([__webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_cdk_fesm2022__breakpoints-observer-chunk_mjs-_5dc71")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	21751: {
		fallback: () => (__webpack_require__.e("node_modules_broadcast-channel_dist_esbrowser_index_js").then(() => (() => (__webpack_require__(/*! broadcast-channel */ 77547))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "broadcast-channel",

	},
	96465: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_graphql-tag_lib_index_js")]).then(() => (() => (__webpack_require__(/*! graphql-tag */ 89067))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.12.7",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "graphql-tag",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		6078
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		93649
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		50064
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		67629
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		24951
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		82512,
		69930
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		48394
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		65428
	],
	"default-node_modules_auth0_auth0-angular_fesm2022_auth0-auth0-angular_mjs": [
		69347
	],
	"default-webpack_sharing_consume_default_azure_msal-browser_azure_msal-browser": [
		29941
	],
	"default-webpack_sharing_consume_default_ngrx_store_ngrx_store": [
		44525
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		69066
	],
	"default-webpack_sharing_consume_default_snelstart_util-state-store_snelstart_util-state-store": [
		68983
	],
	"default-webpack_sharing_consume_default_snelstart_util-events_snelstart_util-events": [
		65041
	],
	"default-webpack_sharing_consume_default_snelstart_util_snelstart_util": [
		47051
	],
	"default-webpack_sharing_consume_default_snelstart_models-environment_snelstart_models-environment": [
		4763
	],
	"default-webpack_sharing_consume_default_snelstart_util-address_snelstart_util-address-webpack-ca206b": [
		48373,
		7853
	],
	"default-webpack_sharing_consume_default_snelstart_ui-icon_snelstart_ui-icon": [
		81545
	],
	"default-webpack_sharing_consume_default_snelstart_ui-badge_snelstart_ui-badge": [
		91767
	],
	"default-libs_shared_feature-navigation-bar_src_index_ts": [
		81881
	],
	"default-libs_shared_ui-action-sheet_src_index_ts": [
		51596,
		11240,
		44272
	],
	"default-webpack_sharing_consume_default_snelstart_ui-button_snelstart_ui-button": [
		98969
	],
	"default-webpack_sharing_consume_default_snelstart_ui-tooltip_snelstart_ui-tooltip": [
		80271
	],
	"default-webpack_sharing_consume_default_snelstart_util-route-state_snelstart_util-route-state": [
		2983
	],
	"default-webpack_sharing_consume_default_snelstart_ui-loading_snelstart_ui-loading-webpack_sha-d03ddc": [
		45497,
		52191
	],
	"default-webpack_sharing_consume_default_bootstrap_bootstrap": [
		95807
	],
	"default-webpack_sharing_consume_default_snelstart_util-logging_snelstart_util-logging": [
		78807
	],
	"default-webpack_sharing_consume_default_snelstart_ui-alert_snelstart_ui-alert": [
		65541
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		1086
	],
	"default-webpack_sharing_consume_default_snelstart_ui-dialog_snelstart_ui-dialog-webpack_shari-db06a5": [
		3853,
		44371
	],
	"default-webpack_sharing_consume_default_snelstart_ui-action-sheet_snelstart_ui-action-sheet": [
		76909
	],
	"default-libs_shared_ui-form-controls_src_index_ts": [
		64929,
		21681,
		45850
	],
	"default-webpack_sharing_consume_default_snelstart_util-feature-flag_snelstart_util-feature-flag": [
		78001
	],
	"default-libs_shared_util-events_src_index_ts": [
		40107
	],
	"default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular": [
		95341
	],
	"default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt": [
		66832
	],
	"default-libs_shared_util_src_index_ts": [
		20188,
		21751
	],
	"default-webpack_sharing_consume_default_graphql-tag_graphql-tag-node_modules_apollo_client_ma-f02123": [
		96465
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}